// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cyyPguIi{background-color:#f5f6ff;padding:max(3rem,min(4.17vw,5rem)) 0}.yXY1pfZN>*+*,.gH-3Uae\\+>*+*{margin-top:max(2rem,min(2.92vw,3.5rem))}.MXb0EvtD{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:1.25rem;gap:1.25rem}@media(max-width:667.98px){.MXb0EvtD{grid-template-columns:repeat(1,1fr)}}.jftRf\\+qp{grid-column:1/-1}.ROPYHjQj{display:none}.CsszkIkO>*+*{margin-top:1.5rem}.MbZHGg0x{align-items:center;display:flex;gap:max(2rem,min(2.92vw,3.5rem))}.myvpMf99{font-size:.75rem;line-height:1.4;max-width:70ch;text-wrap:balance}.myvpMf99 a{color:#32388c}@media(hover:hover){.myvpMf99 a:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.myvpMf99 a:active{-webkit-text-decoration:underline;text-decoration:underline}}.L5dBWLCF{color:#bf2333}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "cyyPguIi",
	"form": "yXY1pfZN",
	"inner": "gH-3Uae+",
	"formFields": "MXb0EvtD",
	"formMessage": "jftRf+qp",
	"formCaptcha": "ROPYHjQj",
	"footer": "CsszkIkO",
	"footerStart": "MbZHGg0x",
	"footerText": "myvpMf99",
	"footerError": "L5dBWLCF"
};
module.exports = ___CSS_LOADER_EXPORT___;
